export default "__VITE_ASSET__DE60YcLR__"